<template>
    <div class="operation_box">
        <div class="operation_item">
			<md-button class="md-primary" @click="displayModal">
				<i class="fa fa-pencil" style="text-align: left"></i>
				<span>{{ $t("common.edit") }}</span>
			</md-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
		displayModal() {
			this.params.showEditModal(this.params.data.ratedCompanyId);
        }
    }
};
</script>